var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotdog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5350_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    d: "m251.8 53c5.3-27.9 29.7-48 58.1-48 108.9 0 197.1 88.2 197.1 197.1 0 168.4-136.5 304.9-304.9 304.9-108.9 0-197.1-88.2-197.1-197.1 0-28.4 20.2-52.7 48-58.1 100.8-19.2 179.6-98 198.8-198.8z",
    fill: "#ffb233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1463_",
    d: "m35 339.9c0-28.4 20.2-52.7 48-58.1 100.8-19.2 179.6-98 198.8-198.8 5.3-27.9 29.7-48 58.1-48 46.8 0 89.8 16.3 123.6 43.5-36.2-44.8-91.5-73.5-153.6-73.5-28.4 0-52.7 20.2-58.1 48-19.2 100.8-98 179.6-198.8 198.8-27.9 5.3-48 29.7-48 58.1 0 62.1 28.7 117.4 73.5 153.6-27.2-33.8-43.5-76.8-43.5-123.6z",
    fill: "#ffc970"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1337_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    d: "m70 464.6c-35.9 0-65-29.1-65-65 0-35.9 29.1-65 65-65 145.8 0 264-118.2 264-264 0-35.9 29.1-65 65-65 35.9 0 65 29.1 65 65 0 217.6-176.4 394-394 394z",
    fill: "#d84861"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2397_",
    d: "m460.4 124c-4.1-.7-8.3-1-12.5-1-37.9 0-70.6 27-77.7 64.3-17.8 93.3-89.6 165.1-182.9 182.9-37.3 7.1-64.3 39.8-64.3 77.7 0 4.4.4 8.8 1.1 13 174.6-23.9 312.7-162.2 336.3-336.9z",
    fill: "#c12944"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1333_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1334_",
    d: "m95.5 381.9c-5.5-1.4-8.7-7.1-7.1-12.6 1.9-6.3 4.8-14.8 8.5-23.6 10.5-25.3 21.9-39.3 34.7-42.6 11.7-3 23.6 7.9 38.7 21.7 6 5.5 12.2 11.2 17.7 15.2 4.5 3.3 7.1 4.5 8.5 4.9 1.6-5.2 1.3-18.9 1.1-27.3-.5-21.3-.9-41.3 10.9-49.5 10.5-7.3 26.1-1 45.8 7 8.7 3.5 24.5 9.9 30.1 9.4.5-5.6-5.9-21.4-9.4-30.1-8-19.7-14.3-35.3-7-45.8 8.2-11.8 28.2-11.4 49.5-10.9 8.5.2 22.1.5 27.3-1.1-.4-1.4-1.6-4.1-4.9-8.5-4.1-5.5-9.7-11.7-15.2-17.7-13.8-15.1-24.7-27-21.7-38.7 3.3-12.8 17.3-24.2 42.6-34.7 8.8-3.7 17.3-6.5 23.6-8.5 5.4-1.7 11.2 1.5 12.6 7.1 1.3 5.1-1.6 10.4-6.7 12-24.4 7.4-48.9 19.3-52.5 28.3 1.5 4.2 10.6 14.3 16.8 21 15.9 17.3 30.8 33.7 24 48.8-5.9 12.9-24.6 12.5-46.4 12-7.8-.2-15.9-.3-22.4.2-6.2.5-8.9 1.5-9.9 2-.2 4.9 5.4 18.6 8.8 27 8.5 21 16.5 40.8 5.3 52s-31 3.2-52-5.3c-8.4-3.4-22.1-8.9-27-8.8-.5 1-1.5 3.7-2 9.9-.5 6.5-.4 14.6-.2 22.4.5 21.7.9 40.5-12 46.4-2.6 1.2-5.2 1.7-7.9 1.7-12.9 0-26.6-12.5-41-25.7-6.7-6.2-16.8-15.3-21-16.8-9 3.6-21 28.1-28.3 52.5-1.4 5.1-6.7 8.1-11.9 6.7z",
    fill: "#ffdca3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    d: "m389.8 191c5.3-27.9 29.7-48 58.1-48 32.6 0 59.1 26.5 59.1 59.1 0 168.4-136.5 304.9-304.9 304.9-32.6 0-59.1-26.5-59.1-59.1 0-28.4 20.2-52.7 48-58.1 100.8-19.2 179.6-98 198.8-198.8z",
    fill: "#ffc970"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotdog);
export default __webpack_public_path__ + "static/media/hotdog.94d7770dab65dc70c803e74467243f0b.svg";
export { ForwardRef as ReactComponent };